import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { postLayout } from 'api/layout.service';
import { notificationActions } from 'redux/notification/notification.slice';
import { NewLayoutRequest } from 'types/entity';

export const LAYOUT_CREATE_STORE_NAME = 'layoutCreate';

export const createLayouts = createAsyncThunk(
  `${LAYOUT_CREATE_STORE_NAME}/create`,
  async (payload: { projectId: string, newLayoutRequest: NewLayoutRequest }, thunkAPI) => {
    const { projectId, newLayoutRequest } = payload;
    await postLayout(projectId, newLayoutRequest);
    thunkAPI.dispatch(notificationActions.addSuccess({ messageId: 'notification.layoutCreate.success' }));
  },
);

export interface LayoutCreateState {
  processing: boolean
  succeeded: boolean
  error: any
}

export const initialLayoutCreateState: LayoutCreateState = {
  processing: false,
  succeeded: false,
  error: null,
};

export const layoutCreateSlice = createSlice({
  name: LAYOUT_CREATE_STORE_NAME,
  initialState: initialLayoutCreateState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createLayouts.pending, (state) => {
      state.processing = true;
    });
    builder.addCase(createLayouts.fulfilled, (state) => {
      state.processing = false;
      state.succeeded = true;
    });
    builder.addCase(createLayouts.rejected, (state, action) => {
      state.error = action.payload;
      state.processing = false;
    });
  },
});

export const layoutCreateActions = {
  ...layoutCreateSlice.actions,
  createLayouts,
};

export default layoutCreateSlice.reducer;
